import React from 'react';
import qs from 'query-string';

import Layout from '../_layout/layout';
import SEO from '../_layout/seo';
import BreadCrumbs from '../_components/shares/breadcrumbs';
import Companies from '../_components/companiespage/companies';

import CompaniesPageCover from '../_components/companiespage/cover';

// import SidebarExternalArticlesLatest from '../_components/shares/sidebar-external-articles-latest';
import JournalFeaturedPosts from '../_components/shares/journal-featured-posts';
import HomeBenefits from '../_components/homepage/benefits';
import SidebarAds from '../_components/shares/sidebar-ads';

class CompaniesPage extends React.Component {
  render() {
    const { search } = this.props.location;
    const params = qs.parse(search);
    const companyName = params.name;
    const companyIndustry = params.industry;
    const companyPrefecture = params.prefecture;
    const companySalary = params.salary;
    const pageParam = parseInt(params.page, 10);
    const currentPage = pageParam > 1 ? pageParam : 1;

    let breadcrumbs = [
      {
        name: '企業一覧',
        to: '/companies/',
      },
    ];

    return (
      <Layout>
        <SEO />
        <BreadCrumbs bclinks={breadcrumbs} />

        <CompaniesPageCover />

        <div className="container-fluid px-0 max-1100">
          <div className="row mx-0">
            <div className="col-lg-9 col-12">
              <Companies
                {...this.props}
                companyName={companyName}
                companyIndustry={companyIndustry}
                companyPrefecture={companyPrefecture}
                companySalary={companySalary}
                currentPage={currentPage}
              />
            </div>
            {/*  */}
            <div className="col-lg-3 col-12 sidebar-wrapper">
              <SidebarAds />
              {/* benefits list */}
              <div className="sidebar-wrapper-content">
                <div className="sidebar-wrapper-title">
                  <span className="text-green">働き方情報をみる</span>
                </div>
                <HomeBenefits />
              </div>
              <JournalFeaturedPosts />
              {/* <SidebarExternalArticlesLatest /> */}
            </div>
          </div>
        </div>
      </Layout>
    );
  }
}

export default CompaniesPage;
